<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Edit Campaign Fields ({{ campaignDetails['campaign_name'] }})</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <form-wizard
        color="rgba(var(--vs-dark), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="formSubmitted"
        @on-change="getMandatorySelectedFields"
      >
        <tab-content title="Master Fields" class="mb-5 mt-10">
          <!-- tab 3 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Master Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="master_fields"
              :destination="selectedMasterFields"
              label="name"
              @onChangeList="onMasterFieldChangeList"
            />
          </div>
        </tab-content>
        <tab-content title="Primary Client Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Primary Client Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="primary_client_fields"
              :destination="selectedClientFields"
              label="name"
              @onChangeList="onClientFieldChangeList"
            />
          </div>
        </tab-content>
        <tab-content title="Campaign Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Campaign Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="campaign_fields"
              :destination="selectedCampaignFields"
              label="name"
              @onChangeList="onCampaignFieldChangeList"
            />
          </div>
        </tab-content>
         <tab-content title="Opportunity Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Opportunity Fields</h5>
              </div>
            </vs-col>
             <DualListBox
              :source="opportunity_fields"
              :destination="selectedOpportunityFields"
              label="name"
              @onChangeList="onOpportunityFieldChangeList"
            />
          </div>
        </tab-content>
        <tab-content title="Database Core Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Account Core Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="account_core_fields"
              :destination="selectedAccountCoreFields"
              label="name"
              @onChangeList="onAccountCoreFieldChangeList"
            />
          </div>

          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Contact Core Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="contact_core_fields"
              :destination="selectedContactCoreFields"
              label="name"
              @onChangeList="onContactCoreFieldChangeList"
            />
          </div>

   
        </tab-content>
        <tab-content title="Mandatory Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Mandatory Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="mandatory_fields"
              :destination="selectedMandatoryFields"
              label="name"
              @onChangeList="onMandatoryFieldChangeList"
            />
          </div>
        </tab-content>
      </form-wizard>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
// import vMultiselectListbox from "vue-multiselect-listbox";
// import "vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss";
// Vue.component("v-multiselect-listbox", vMultiselectListbox);
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";

export default {
  data() {
    return {
      campaignDetails: [],
      selectedOpportunityFields: [],
      opportunity_fields:[],
      selectedAccountCoreFields: [],
      selectedContactCoreFields: [],
      account_core_fields: [
      ],
      contact_core_fields: [
      ],
      campaign_required: null,
      companySearchComponentKey: 0,
      selectedMasterFields: [],
      selectedClientFields: [],
      selectedCampaignFields: [],
      campaign_fields: [],
      master_fields: [],
      primary_client_fields: [],
      selected_campaign_id: null,
      mandatory_fields: [],
      selectedMandatoryFields: [],
    };
  },
  methods: {
    getMandatorySelectedFields(){
  
      let self = this

  this.mandatory_fields = this.selectedAccountCoreFields.concat(this.selectedContactCoreFields , this.selectedMasterFields, this.selectedClientFields, this.selectedCampaignFields, this.selectedOpportunityFields)



  self.mandatory_fields = self.mandatory_fields.filter(md => self.selectedMandatoryFields.every(fd => fd.name != md.name && fd.description != md.description));

  // console.log(this.mandatory_fields)
  // console.log(this.selectedMandatoryFields)


  // this.mandatory_fields = this.selectedCoreFields



},
    onMasterFieldChangeList: function({ source, destination }) {
      this.master_fields = source;
      this.selectedMasterFields = destination;
    },
    onClientFieldChangeList: function({ source, destination }) {
      this.primary_client_fields = source;
      this.selectedClientFields = destination;
    },
    onCampaignFieldChangeList: function({ source, destination }) {
      this.campaign_fields = source;
      this.selectedCampaignFields = destination;
    },
    onAccountCoreFieldChangeList: function({ source, destination }) {
      this.account_core_fields = source;
      this.selectedAccountCoreFields = destination;
    },
    onContactCoreFieldChangeList: function({ source, destination }) {
      this.contact_core_fields = source;
      this.selectedContactCoreFields = destination;
    },
    onOpportunityFieldChangeList: function({ source, destination }) {
      this.opportunity_fields = source;
      this.selectedOpportunityFields = destination;
    },
    onMandatoryFieldChangeList: function({ source, destination }) {
  this.mandatory_fields = source;
  this.selectedMandatoryFields = destination;
},
    formSubmitted() {
      this.updateMasterFieldsToCampaign();
      this.$router.go(-1);
      this.$router.push({ path: "/campaigns/list-more-field" });

      // alert("Form submitted!");
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getAllCoreFields() {
      let self = this;
      self.$store
        .dispatch("campaignsManagement/getAllCoreFields")
        .then(response => {
          response.data.forEach(function(ele) {
            if(ele.level == 'account'){
              self.account_core_fields.push(ele)
            }else if(ele.level == 'contact'){
              self.contact_core_fields.push(ele)
            }
          });
          // self.account_core_fields = response.data;
          // self.core_fields = response.data;
          self.getAllMasterFields();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllMasterFields() {
      let self = this;
      self.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          self.master_fields = response.data;
          self.master_fields = self.master_fields.filter(ele => ele.sales_developer_access == true)
          self.getPrimaryClientFields();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSelectedAccountCoreFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedAccountCoreFields",
          selected_campaign_id
        )
        .then(response => {

          let result = JSON.parse(response.data);

          if (result.length != 0) {
            result.forEach(function(ele) {
              ele.id = ele.uuid
              self.selectedAccountCoreFields.push(ele);
            });
          }

          self.account_core_fields = self.account_core_fields.filter(
            ({ id: id1 }) =>
              !self.selectedAccountCoreFields.some(({ uuid: id2 }) => id2 === id1)
          );


          // let result = JSON.parse(response.data);
          // if(result.length != 0){
          //   let selected_column = JSON.parse(result[0]['selected_column']);

          //   selected_column.forEach(function(ele) {
          //     let newObj = {}
          //     newObj.name = ele;
          //     newObj.field_name = ele;
          //     self.selectedAccountCoreFields.push(newObj);
          //   });
          // }

          // self.account_core_fields = self.account_core_fields.filter(
          //   ({ name: id1 }) =>
          //     !self.selectedAccountCoreFields.some(
          //       ({ name: id2 }) => id2 === id1
          //     )
          // );
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedContactCoreFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedContactCoreFields",
          selected_campaign_id
        )
        .then(response => {

          let result = JSON.parse(response.data);

if (result.length != 0) {
  result.forEach(function(ele) {
    ele.id = ele.uuid
    self.selectedContactCoreFields.push(ele);
  });
}

self.contact_core_fields = self.contact_core_fields.filter(
  ({ id: id1 }) =>
    !self.selectedContactCoreFields.some(({ uuid: id2 }) => id2 === id1)
);


          // let result = JSON.parse(response.data);
          // if(result.length != 0){
          //   let selected_column = JSON.parse(result[0]['selected_column']);

          //   selected_column.forEach(function(ele) {
          //     let newObj = {}
          //     newObj.name = ele;
          //     newObj.field_name = ele;
          //     self.selectedContactCoreFields.push(newObj);
          //   });
          // }
          // self.contact_core_fields = self.contact_core_fields.filter(
          //   ({ name: id1 }) =>
          //     !self.selectedContactCoreFields.some(
          //       ({ name: id2 }) => id2 === id1
          //     )
          // );
         
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getSelectedMandatoryFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMandatoryFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {
            result.forEach(function(ele) {

              console.log("ELE" , ele)
                ele.id = ele.field_id
             
              self.selectedMandatoryFields.push(ele);
            });
          }

          // self.mandatory_fields = self.mandatory_fields.filter(
          //   ({ id: id1 }) =>
          //     !self.selectedMandatoryFields.some(({ uuid: id2 }) => id2 === id1)
          // );
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getSelectedMasterFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedMasterFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {
            result.forEach(function(ele) {
              ele.id = ele.uuid
              self.selectedMasterFields.push(ele);
            });
          }

          self.master_fields = self.master_fields.filter(
            ({ id: id1 }) =>
              !self.selectedMasterFields.some(({ uuid: id2 }) => id2 === id1)
          );
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getSelectedClientFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/getSelectedClientFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);

          if (result.length != 0) {
            result.forEach(function(ele) {
                            ele.id = ele.uuid

              self.selectedClientFields.push(ele);
            });
          }

          self.primary_client_fields = self.primary_client_fields.filter(
            ({ id: id1 }) =>
              !self.selectedClientFields.some(({ uuid: id2 }) => id2 === id1)
          );
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getSelectedCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/getSelectedCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);
          if (result.length != 0) {
            result.forEach(function(ele) {
              ele.id = ele.uuid
              self.selectedCampaignFields.push(ele);
            });
          }
          self.campaign_fields = self.campaign_fields.filter(
            ({ id: id1 }) =>
              !self.selectedCampaignFields.some(({ uuid: id2 }) => id2 === id1)
          );
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getSelectedOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFields",
          selected_campaign_id
        )
        .then(response => {
          let result = JSON.parse(response.data);
          if (result.length != 0) {
            result.forEach(function(ele) {
              ele.id = ele.uuid
              self.selectedOpportunityFields.push(ele);
            });
          }
          self.opportunity_fields = self.opportunity_fields.filter(
            ({ id: id1 }) =>
              !self.selectedOpportunityFields.some(({ uuid: id2 }) => id2 === id1)
          );
        })
        .catch(err => {

          console.log(err)
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getPrimaryClientFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchPrimaryClientFields",
          selected_campaign_id
        )
        .then(response => {
          self.primary_client_fields = response.data;
          self.primary_client_fields = self.primary_client_fields.filter(ele => ele.sales_developer_access == true)

          self.getCampaignFields();
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          self.campaign_fields = response.data;
          self.campaign_fields = self.campaign_fields.filter(ele => ele.sales_developer_access == true)
          self.getOpportunityFields()
          

        })
        .catch(err => {
          // if (err.response.status === 404) {
          //   return;
          // }
          console.error(err);
        });
    },
    getOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchOpportunityFields",
          selected_campaign_id
        )
        .then(response => {

          console.log("OPP FIELDS" , response)
          self.opportunity_fields = response.data;
          self.getSelectedMasterFields();
          self.getSelectedClientFields();
          self.getSelectedCampaignFields();
          self.getSelectedAccountCoreFields();
          self.getSelectedContactCoreFields();
          self.getSelectedOpportunityFields();
          self.getSelectedMandatoryFields();
          // self.primary_client_fields = self.primary_client_fields.filter(ele => ele.sales_developer_access == true)

        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    updateAccountCoreFieldsToCampaign() {
      let self = this;
      let accountCoreData = [];
      self.selectedAccountCoreFields.forEach(element => {
        let coreObj = {};
        coreObj.core_field_id = element.id;
        coreObj.campaign_id = self.selected_campaign_id;
        accountCoreData.push(coreObj);
      });
      self.updateContactCoreFieldsToCampaign(accountCoreData);
    },
    updateContactCoreFieldsToCampaign(accountCoreData) {
      let self = this;
      let contactCoreData = [];
      self.selectedContactCoreFields.forEach(element => {
        let coreObj = {};
        coreObj.core_field_id = element.id;
        coreObj.campaign_id = self.selected_campaign_id;
        contactCoreData.push(coreObj);
      });

      let all_core_data = [...accountCoreData, ...contactCoreData];



      self.$store
        .dispatch(
          "campaignsManagement/updateContactCoreFieldsToCampaign",
          all_core_data
        )
        .then(res => {
          self.updateMandatoryFieldsToCampaign();
        
        })
        .catch(err => {
          console.log(err);

  
        });
    },
    updateMandatoryFieldsToCampaign() {
      let self = this;
      let mandatoryData = [];

       console.log("SELECTED MANDATORY FIELDS" , self.selectedMandatoryFields)
      //  return false

      self.selectedMandatoryFields.forEach(element => {
        let mandatoryObj = {};
        mandatoryObj.mandatory_field_id = element.id;
        mandatoryObj.campaign_id = self.selected_campaign_id;
        mandatoryData.push(mandatoryObj);
      });

      console.log("MANDATORY DATA" , mandatoryData)

      self.$store
        .dispatch("campaignsManagement/updatMandatoryFieldsToCampaign", mandatoryData)
        .then(res => {
          self.updateOverallCampaignFieldsWithCampaignId();
          console.log(res);
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    updateOverallCampaignFieldsWithCampaignId() {
      let self = this;
      let campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/updateOverallCampaignFieldsWithCampaignId",
          campaign_id
        )
        .then(res => {

          console.log("REEEEE" , res)
            self.$vs.notify({
              color: "success",
              title: "Selected Field for Campaign",
              text: "The fields have been successfully updated."
            });
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    updateMasterFieldsToCampaign() {
      let self = this;
      let masterData = [];
      self.selectedMasterFields.forEach(element => {
        let masterObj = {};
        masterObj.master_field_id = element.id;
        masterObj.campaign_id = self.selected_campaign_id;
        masterData.push(masterObj);
      });

      self.$store
        .dispatch(
          "campaignsManagement/updateMasterFieldsToCampaign",
          masterData
        )
        .then(res => {
          self.updateClientFieldsToCampaign();
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    updateClientFieldsToCampaign() {
      let self = this;
      let clientData = [];
      self.selectedClientFields.forEach(element => {
        let clientObj = {};
        clientObj.client_field_id = element.id;
        clientObj.campaign_id = self.selected_campaign_id;
        clientData.push(clientObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/updateClientFieldsToCampaign",
          clientData
        )
        .then(res => {
          self.updateCampaignFieldsToCampaign();

        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    updateCampaignFieldsToCampaign() {
      let self = this;
      let campaignData = [];
      self.selectedCampaignFields.forEach(element => {
        let campaignObj = {};
        campaignObj.campaign_field_id = element.id;
        campaignObj.campaign_id = self.selected_campaign_id;
        campaignData.push(campaignObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/updateCampaignFieldsToCampaign",
          campaignData
        )
        .then(res => {
          self.updateOpportunityFieldsToCampaign();
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    updateOpportunityFieldsToCampaign() {
      let self = this;
      let opportunityData = [];
      self.selectedOpportunityFields.forEach(element => {
        let opportunityObj = {};
        opportunityObj.opportunity_field_id = element.id;
        opportunityObj.campaign_id = self.selected_campaign_id;
        opportunityData.push(opportunityObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/updateOpportunityFieldsToCampaign",
          opportunityData
        )
        .then(res => {
          self.updateAccountCoreFieldsToCampaign();
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchCampaignDetails() {
      this.$store
        .dispatch("campaignsManagement/fetchCampaign", this.$route.params.campaignId)
        .then(res => {
          this.campaignDetails = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchCampaignDetails()
    this.getAllCoreFields();

    // if (localStorage.getItem("reloaded-fields")) {
    //   // The page was just reloaded. Clear the value from local storage
    //   // so that it will reload the next time this page is visited.
    //   localStorage.removeItem("reloaded-fields");
    // } else {
    //   // Set a flag so that we know not to reload the page twice.
    //   localStorage.setItem("reloaded-fields", "1");
    //   location.reload();
    // }
  },
  created() {
    this.selected_campaign_id = this.$route.params.campaignId;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  components: {
    FormWizard,
    TabContent,
    CampaignAutocomplete,
    DualListBox
  }
};
</script>
<style>
.msl-search-list-input {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}

.msl-searchable-list__item {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}
.msl-multi-select__actions {
  font-size: 25px;
}

.msl-multi-select {
  width: 100%;
}
</style>
